import { addonsModalsContent } from '@web/components/AddOnQuickView/constants';
import supplementImage from '../../images/our-food/addons/Skin-Supplement.jpg';
import treatImage from '../../images/our-food/addons/Jerky-Beef-Sweet-Potato-Treat.jpg';
import {
  ADDON_SKUS as addonSkus,
  supplementsDropdownsAndValues,
  treatsDropdownsAndValues,
} from '../../testing/constants';

const EXTRAS_FAQS = [
  {
    question: 'How is Ollie Made?',
    answer:
      'Short answer: with a whole lotta love. Longer answer: We started by working with a veterinary nutritionist who helped us formulate our balanced and complete, human-grade recipes, abiding by the AAFCO standards. Then we carefully sourced our ingredients (more on this below!), cook them at low temperatures in small batches at our facility in New Jersey, and hand-pack them. We personally know the people who are making the food—and our dogs can attest to how delicious it is.',
  },
  {
    question: 'Where are the ingredients sourced from?',
    answer:
      "Serious talk: We source our hormone-free* chicken and beef from high-quality, human-grade farms in the US. And our premium, pasture-raised lamb comes from free-range farms in the US and Australia. Our produce, seeds and oils are carefully sourced and there's absolutely no fillers, artificial flavoring, or preservatives in our food. Ever. *Federal regulations prohibit the use of hormones in poultry",
  },
  {
    question: 'When is it shipped?',
    answer:
      "Our food is shipped on a regular schedule according to your meal plan, and you can expect to get it on the same day each week. However, that date may change if there is a major holiday or when there's inclement weather. We will contact you if your shipment schedule changes.",
  },
  {
    question: 'When am I charged?',
    answer:
      'The card on your account is charged on a regular schedule in accordance with your shipments.',
  },
];

export const FAQ_PROPS = {
  faqs: EXTRAS_FAQS,
  headline: 'Learn more about our treats and supplements',
};

export const addons = [
  {
    sku: addonSkus.zoomies,
    description:
      'A real Catch: Tasty treats mad with wild-caught salmon, coconut, and oats.',
    title: 'Zoomies',
    productType: 'TR',
    subtitle: 'Soft Chew Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '37',
      discountedPrice: '25',
    },
    image: {
      src: treatImage.src,
      alt: 'Treat Image Image',
      width: treatImage.width,
      height: treatImage.height,
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.turkeyjerky,
    title: 'Chill Pills',
    productType: 'TR',
    description:
      'A real Catch: Tasty treats mad with wild-caught salmon, coconut, and oats.',
    subtitle: 'Soft Chew Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '37',
      discountedPrice: '25',
    },
    image: {
      src: treatImage.src,
      alt: 'Treat Image Image',
      width: treatImage.width,
      height: treatImage.height,
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.beefjerky,
    title: 'Beef Jerky',
    productType: 'TR',
    description:
      'A real Catch: Tasty treats mad with wild-caught salmon, coconut, and oats.',
    subtitle: 'Soft Chew Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '37',
      discountedPrice: '25',
    },
    image: {
      src: treatImage.src,
      alt: 'Treat Image Image',
      width: treatImage.width,
      height: treatImage.height,
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.bellyrubs,
    title: 'Belly Rubs',
    productType: 'SP',
    subtitle: 'Soft Chew Treats',
    description:
      'A real Catch: Tasty treats mad with wild-caught salmon, coconut, and oats.',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '37',
      discountedPrice: '25',
    },
    image: {
      src: supplementImage.src,
      alt: 'Supplement Image Image',
      width: supplementImage.width,
      height: supplementImage.height,
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
  {
    sku: 'Supplement 2',
    title: 'Just Chicken Strips',
    productType: 'SP',
    subtitle: 'Soft Chew Treats',
    description:
      'A real Catch: Tasty treats mad with wild-caught salmon, coconut, and oats.',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '37',
      discountedPrice: '25',
    },
    image: {
      src: supplementImage.src,
      alt: 'Supplement Image Image',
      width: supplementImage.width,
      height: supplementImage.height,
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
];

export const addonFormProps = {
  headline: 'Would Bella like a treat or supplement?',
  subheadline: 'Select items to add to Bella’s box',
  defaultAddons: [
    {
      sku: addonSkus.zoomies,
      title: 'Just Chicken Strips',
      productType: 'TR',
      subtitle: 'Soft Chew Treats',
      size: '1 bag (5oz.)',
      pricingInfo: {
        price: '37',
        discountedPrice: '25',
      },
      quantity: 2,
      frequency: 2,
      image: {
        src: treatImage.src,
        alt: 'Treat Image Image',
        width: treatImage.width,
        height: treatImage.height,
      },
      dropdowns: treatsDropdownsAndValues.dropdowns,
    },
  ],
  addonSections: [
    {
      heading: 'Treats',
      addons: addons.slice(0, 3),
    },
    {
      heading: 'Supplements',
      addons: addons.slice(3, 5),
    },
  ],
  modals: addonsModalsContent.map(content => ({
    ...content,
    ...{
      pupInfo: {
        pupName: 'Panda',
        pupPronoun: 'him',
        addonServingFrequency: '2 weeks',
      },
    },
  })),
  unavailableAddons: [],
  onChange: () => {},
  onSubmit: () => {},
  onSkipButtonClick: () => {},
  cancelButtonText: 'Cancel',
  submitButtonText: 'Continue',
  pillText: 'Free Salmon Jerky Strips!',
  faqProps: FAQ_PROPS,
};

export const NOT_SELECTABLE_TEXT =
  'To choose this item, please remove one of your previous selections.';
